import { StringPathToPathSegments } from './convert';
import { GetProcess } from '../helpers/helpers';
export function GetProcessPathSegments(options) {
    return StringPathToPathSegments(GetProcess().cwd(), options);
}
//# sourceMappingURL=others.js.map